import { useIntl } from "react-intl";
import { useCallback, useMemo } from "react";

interface DurationOpts {
  lowercase?: boolean;
}

export function useDurationFormat(opts?: DurationOpts) {
  const intl = useIntl();

  const formatYears = useCallback(
    (yearCount: number) => {
      if (opts?.lowercase) {
        return intl.formatMessage(
          {
            defaultMessage: "{yearCount, plural, =1 {1 year} other {# years}}",
          },
          { yearCount }
        );
      }
      return intl.formatMessage(
        { defaultMessage: "{yearCount, plural, =1 {1 Year} other {# Years}}" },
        { yearCount }
      );
    },
    [intl, opts]
  );

  const formatDays = useCallback(
    (dayCount: number) => {
      if (opts?.lowercase) {
        return intl.formatMessage(
          { defaultMessage: "{dayCount, plural, =1 {1 day} other {# days}}" },
          { dayCount }
        );
      }

      return intl.formatMessage(
        { defaultMessage: "{dayCount, plural, =1 {1 Day} other {# Days}}" },
        { dayCount }
      );
    },
    [intl, opts]
  );

  const formatHours = useCallback(
    (duration: number) => {
      if (opts?.lowercase) {
        return intl.formatMessage(
          {
            defaultMessage: "{duration, plural, =1 {1 hour} other {# hours}}",
          },
          { duration }
        );
      }
      return intl.formatMessage(
        {
          defaultMessage: "{duration, plural, =1 {1 Hour} other {# Hours}}",
        },
        { duration }
      );
    },
    [intl, opts]
  );

  return useMemo(
    () => ({ formatYears, formatHours, formatDays }),
    [formatYears, formatDays, formatHours]
  );
}
